import { render, staticRenderFns } from "./FilingGA.vue?vue&type=template&id=4dd8b281"
import script from "./FilingGA.vue?vue&type=script&lang=ts"
export * from "./FilingGA.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports